export const getNameInitials = (firstName: string, surname: string) => {
  return `${(firstName || '')[0] || ''}${(surname || '')[0] || ''}`
}
export default getNameInitials
